import React, { useEffect } from 'react';
import { t } from '../../../i18n';

interface NextActionOverlayProps {
    visible: boolean;
    nextAction: string;
    trackingNumber: string;
    onClose: () => void;
}

const getNextActionConfig = (action: string) => {
    const baseConfigs = {
        ReDeliver: {
            color: 'text-green-600',
            backgroundColor: 'bg-green-500 bg-opacity-30',
        },
        Return: {
            color: 'text-red-600',
            backgroundColor: 'bg-red-500 bg-opacity-30',
        },
        Hold: {
            color: 'text-blue-600',
            backgroundColor: 'bg-blue-500 bg-opacity-30',
        },
        Compensate: {
            color: 'text-orange-600',
            backgroundColor: 'bg-orange-500 bg-opacity-30',
        },
        ReSort: {
            color: 'text-orange-600',
            backgroundColor: 'bg-orange-500 bg-opacity-30',
        },
    };
    
    const baseConfig = baseConfigs[action as keyof typeof baseConfigs];
    if (!baseConfig) return null;
    
    return {
        ...baseConfig,
        text: t(`pda.common.exceptionActions.${action}`)
    };
};

export const NextActionOverlay: React.FC<NextActionOverlayProps> = ({
        visible,
        nextAction,
        trackingNumber,
        onClose,
    }) => {
    const config = getNextActionConfig(nextAction);
    
    useEffect(() => {
        if (visible) {
            const timer = setTimeout(onClose, 3000);
            return () => clearTimeout(timer);
        }
    }, [visible, onClose]);

    if (!config) {
        return null;
    }

    if (!visible) return null;

    return (
        <div 
            className={`fixed inset-0 w-screen h-screen z-50 flex flex-col items-center justify-center transition-opacity duration-200 ${config.backgroundColor}`}
        >
            <div
                className={`text-2xl mb-4 ${config.color}`}
            >
                {t('pda.common.nextAction')}
            </div>
            <div 
                className={`text-5xl font-bold mb-4 ${config.color}`}
            >
                {config.text}
            </div>
            <div 
                className={`text-2xl mb-4 ${config.color}`}
            >
                {trackingNumber}
            </div>
            <div 
                className={`text-2xl ${config.color}`}
            >
                {t('pda.common.keepScanning')}
            </div>
        </div>
    );
};